import { SET_PAGE_TITLE } from './action';

const initialState = {
  title: 'Dashboard',
};

const pageTitleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_TITLE:
      return {
        ...state,
        title: action.payload,
      };

    default:
      return state;
  }
};

export default pageTitleReducer;
